export function SectionTitle ({title}) {
    return (
        <h2 className="text-center text-4xl section-title">{title}</h2>
    )
}
